// extracted by mini-css-extract-plugin
export default {"container":"applications-components-HeaderApp-components-Search-search-module__container","icon":"applications-components-HeaderApp-components-Search-search-module__icon"};
    if(module.hot) {
      // 1708935523584
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  